/**
 * Push notification template type keys (client-safe, for admin UI dropdown).
 * Must match PUSH_NOTIFICATION_TYPES in core/pushNotifications/pushTemplateDefaults.js
 */
export const PUSH_NOTIFICATION_TYPES = [
  'newBooking',
  'newEnquiry',
  'declined',
  'approved',
  'newMessage',
  'preApproved',
  'cancelReservation',
  'approvedDocument',
  'rejectDocument',
  'noHostPayout',
  'expiredServicePlan'

];

/** Placeholders supported per type (for admin UI help text). */
export const PUSH_TEMPLATE_PLACEHOLDERS = {
  newEnquiry: ['userName', 'messageContent'],
  declined: ['userName'],
  approved: ['userName'],
  newMessage: ['userName', 'messageContent'],
  cancelReservation: ['userName', 'messageContent'],
  newBooking: ['userName', 'messageContent'],
  preApprove: ['userName'],
  noHostPayout: [],
  approvedDocument: [],
  rejectDocument: [],
  expiredServicePlan: ['userName', 'planName', 'expiredDate'],
};
